import React, { useEffect, useState } from "react";
import { Container_List } from "../components/Container_List";
import Swal from "sweetalert2";
import request from "../../Helpers/API";

export const AdministracionScreen = () => {
  const [cards, setCards] = useState([]);
  useEffect(() => {
    request
      .get(`MenuUsuarios/AccesosMenus?idmodulo=3`)
      .then((result) => {
        const cards_array = result.map((item) => ({
          titulo: item.titulo,
          ruta: item.ruta,
        }));
        setCards(cards_array);
      })
      .catch((error) => {
        Swal.fire("MENUS COBRANZA", JSON.stringify(error), "error");
      });
  }, []);

  return (
    <Container_List titulo={"LISTADO DE ADMINISTRACION"} cards={cards} />
  );
};
